import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';

/**
 * `<PageContainer>` — centres page content and sets the vertical rhythm. The
 * shell `<main>` owns horizontal padding, so this deliberately has NO px-*.
 */
export interface PageContainerProps {
  children: ReactNode;
  /** Narrow reading width (max-w-3xl) instead of the default max-w-screen-2xl. */
  narrow?: boolean;
  className?: string;
}

export function PageContainer({
  children,
  narrow,
  className,
}: PageContainerProps): JSX.Element {
  return (
    <div
      className={cn(
        'mx-auto w-full min-w-0 space-y-4 sm:space-y-6',
        narrow ? 'max-w-3xl' : 'max-w-screen-2xl',
        className,
      )}
    >
      {children}
    </div>
  );
}

export default PageContainer;
